export default __webpack_public_path__ + "static/KV_IMG_6852_rgb-d20a05c3b3fde585c4cd02875b1d4e8f.jpg";